import Box, { BoxProps } from '@mui/material/Box';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';

import { FaqsCategory } from '../faqs-category';
import { FaqsForm } from '../faqs-form';
import { FaqsList } from '../faqs-list';
import { FaqSection } from '@/types/sections/FaqSection';
import { useState } from 'react';
import { Category } from '@/types/Category';

// ----------------------------------------------------------------------


type FaqsViewProps = BoxProps & {
  section: FaqSection;
};

export function FaqsView({ sx, section, ...other }: FaqsViewProps) {
  const [category, setCatefory] = useState<Category | undefined>(section.categories? section.categories[0] : undefined);

  const handleSelectCategory = (category: Category) => {
    setCatefory(category);
  };

  return (
    <Container component="section" sx={{ textAlign: 'center', py: { xs: 2, md: 10 } }}>
      { section.small && (
        <Typography variant="overline" sx={{ color: 'text.disabled' }}>
          {section.small}
        </Typography>
      )}
      
      { section.title && (
        <Typography variant="h2" sx={{ color: 'primary.main' }}>
          {section.title}
        </Typography>
      )}

      { section.subtitle && (
          <Typography sx={{ color: 'text.secondary', mt: 2 }}>
          {section.subtitle}
        </Typography>
      )}

      { section.categories && (
        <>
          <FaqsCategory categories={section.categories} onCategorySelect={handleSelectCategory} defaultSelected={category?.icon} />

          <Box
            sx={{
              gap: 10,
              display: 'grid',
              gridTemplateColumns: { xs: 'repeat(1, 1fr)', md: 'repeat(2, 1fr)' },
            }}>
            <FaqsList category={category} />
            <FaqsForm />
          </Box>
        </>
      )}
      
      
    </Container>
  );
}
